import { useTranslation } from 'react-i18next'
import { Field } from 'formik';
import _ from 'lodash';
import { cn } from 'utils/utils';
import SmallSubmitButton from './SmallSubmitButton';

export default function SubscribeToNewsLetterSmall ({
  className = '',
  disabled = false,
  errors = {},
  isSubmitting = false,
  onBlur = () => {},
  values = {},
}) {
  const { t } = useTranslation('common')

  const id = `email-${Math.random().toString(36).substring(2, 15)}`

  return (
    <div className={className}>
      <p className="mb-2 font-bold text-xl leading-tight uppercase">{t('heading.subscribe_to_newsletter')}</p>
      <p className="mb-5 text-xs leading-none">{t('text.subscribe_to_newsletter')}</p>
      <div className={cn(
        'relative bg-white rounded-full flex items-center justify-between pl-4 pr-10 py-2 border border-2',
        errors.email ? 'border-red' : 'border-primary',
      )}>
        <Field
          className="max-w-full border-none text-xs placeholder:text-gray-200"
          disabled={disabled || isSubmitting}
          id={id}
          name="email"
          onBlur={(e) => onBlur(e)}
          placeholder={t('field.email')}
          style={{ flex: '1 1 auto'}}
          value={_.get(values, 'email', '')}
        />
        <label className="sr-only" aria-labelledby={id} htmlFor={id}>{t('field.email')}</label>
        <div className="absolute right-0 top-0 bottom-0 grid items-center pr-2">
          <SmallSubmitButton
            disabled={disabled || errors?.email}
            loading={isSubmitting}
          />
        </div>
      </div>
    </div>
  )
}
